export const enum cookieConstants{
    createCookieRequest="CREATE_COOKIE_REQUEST",
    createCookieSuccess="CREATE_COOKIE_SUCCESS",
    createCookieFailure="CREATE_COOKIE_FAILURE",

    getCookieRequest="GET_COOKIE_REQUEST",
    getCookieSuccess="GET_COOKIE_SUCCESS",
    getCookieFailure="GET_COOKIE_FAILURE",

    updateCookieRequest="UPDATE_COOKIE_REQUEST",
    updateCookieSuccess="UPDATE_COOKIE_SUCCESS",
    updateCookieFailure="UPDATE_COOKIE_FAILURE",
    
}